import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import template from './left-side-transactions.vue';

import moment from 'moment'
import 'moment/locale/ro'
moment.locale('ro')

@Component({
    mixins: [template],
})

export default class LeftSideTransactions extends Vue {

    @Prop(Object) readonly auctionData!: object;

    moment: any
    isDeveloper: boolean = false

    created() {
        // When the component gets created.
        this.moment = moment
    }

    mounted() {
        this.isDeveloper = document.cookie.indexOf('dev') !== -1
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/components/left-side-transactions/index.ts